import React from 'react'

import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import { TimeSelector } from '../TimeSelector'

export const TimePicker = ({ onTimeSelected, availableTimes }) => {
  return (
    <Grid
      data-testid="time-picker-container"
      container
      aria-label="time-picker"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      gap={2}
    >
      {availableTimes.map(timeSlot => {
        return (
          <TimeSelector
            key={timeSlot.id}
            timeSlot={timeSlot}
            onTimeSelected={onTimeSelected}
          />
        )
      })}
    </Grid>
  )
}

TimePicker.propTypes = {
  onTimeSelected: PropTypes.func,
  availableTimes: PropTypes.array,
}
